import React from "react";
import { connect } from 'react-redux';
import { Route } from 'react-router-dom';
// import { Route, Redirect } from 'react-router-dom';

function SessionRequiredRoute({component: Component, ...rest}) {
	return (
		<Route
			{...rest}
			render={props => {
				// return rest.sessionID ? <Component {...props} /> : <Redirect to={{ pathname: "/" }} />
				return <Component {...props} />
			}}
		/>
	);
}

const mapStateToProps = (state, ownState) => ({
	sessionID: state.data.sessionID
})

export default connect(mapStateToProps, null)(SessionRequiredRoute);